import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { updateUser } from "../../apis/apisList/userApi";
import { toast } from "react-toastify";
import { useApp } from "../../Context/AppContext";

export default function AddressInformation() {
  const { user } = useApp();
  // Initial data state for address
  const [data, setData] = useState({
    streetAddress: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
  });

  // Edit mode state
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    console.log(">>>>>", user);
    if (!user) return;
    setData({ ...user });
  }, [user]);

  // Edit handler
  const handleEditClick = () => {
    setIsEditing(true);
  };

  // Update handler
  const handleUpdateClick = async () => {
    try {
      await updateUser(user?._id, data);
      setIsEditing(false);
      toast.success("Profile updated successfully!");
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while updating. Please try again."
      );
    }
  };

  // Change handler for input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  return (
    <Box className="personalTable">
      <Typography
        className="tableHeading"
        variant="h6"
        gutterBottom
        sx={{
          padding: "10px 15px",
          backgroundColor: "#EBEBEB",
          fontSize: { xs: "16px", sm: "17px", md: "1.25rem" },
        }}
      >
        Address Information
        <IconButton sx={{ marginLeft: 5 }} onClick={handleEditClick}>
          <EditIcon />
        </IconButton>
      </Typography>
      <TableContainer sx={{ maxWidth: 600 }}>
        <Table>
          <TableBody sx={{ backgroundColor: "#F8F8F8" }}>
            <TableRow>
              <TableCell className="perTblLabel">Street Address:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField
                    name="streetAddress"
                    value={data.streetAddress}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                  />
                ) : (
                  data.streetAddress
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">City:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField
                    name="city"
                    value={data.city}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                  />
                ) : (
                  data.city
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">State/Province:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField
                    name="state"
                    value={data.state}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                  />
                ) : (
                  data.state
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">Postal Code:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField
                    name="postalCode"
                    value={data.postalCode}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                  />
                ) : (
                  data.postalCode
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="perTblLabel">Country:</TableCell>
              <TableCell className="perTbUsrInfo">
                {isEditing ? (
                  <TextField
                    name="country"
                    value={data.country}
                    onChange={handleChange}
                    fullWidth
                    variant="outlined"
                  />
                ) : (
                  data.country
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {isEditing && (
        <Box sx={{ marginTop: 2 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleUpdateClick}
          >
            Update
          </Button>
        </Box>
      )}
    </Box>
  );
}
